/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { CatalogItemReportsQueueDTO } from "../model";
import {
  CatalogItemReportsQueueDTOTrackedI,
  CatalogItemReportsQueueDTOMeta,
} from "../model";
// @ts-ignore
import type { CatalogItemReportsResultDTO } from "../model";
import {
  CatalogItemReportsResultDTOTrackedI,
  CatalogItemReportsResultDTOMeta,
} from "../model";
// @ts-ignore
import type { DailySummaryReportsDTO } from "../model";
import {
  DailySummaryReportsDTOTrackedI,
  DailySummaryReportsDTOMeta,
} from "../model";
// @ts-ignore
import type { InvalidSignupReportsQueueDTO } from "../model";
import {
  InvalidSignupReportsQueueDTOTrackedI,
  InvalidSignupReportsQueueDTOMeta,
} from "../model";
// @ts-ignore
import type { InvalidSignupReportsResultDTO } from "../model";
import {
  InvalidSignupReportsResultDTOTrackedI,
  InvalidSignupReportsResultDTOMeta,
} from "../model";
// @ts-ignore
import type { ItemType } from "../model";
import { ItemTypeTrackedI, ItemTypeMeta } from "../model";
// @ts-ignore
import type { OrderReportsQueueDTO } from "../model";
import {
  OrderReportsQueueDTOTrackedI,
  OrderReportsQueueDTOMeta,
} from "../model";
// @ts-ignore
import type { OrderReportsResultDTO } from "../model";
import {
  OrderReportsResultDTOTrackedI,
  OrderReportsResultDTOMeta,
} from "../model";
// @ts-ignore
import type { OrderStateNew } from "../model";
import { OrderStateNewTrackedI, OrderStateNewMeta } from "../model";
// @ts-ignore
import type { PaymentReportsQueueDTO } from "../model";
import {
  PaymentReportsQueueDTOTrackedI,
  PaymentReportsQueueDTOMeta,
} from "../model";
// @ts-ignore
import type { PaymentReportsResultDTO } from "../model";
import {
  PaymentReportsResultDTOTrackedI,
  PaymentReportsResultDTOMeta,
} from "../model";
// @ts-ignore
import type { PaymentStatus } from "../model";
import { PaymentStatusTrackedI, PaymentStatusMeta } from "../model";
// @ts-ignore
import type { PaymentType } from "../model";
import { PaymentTypeTrackedI, PaymentTypeMeta } from "../model";
// @ts-ignore
import type { StripePaymentReportsQueueDTO } from "../model";
import {
  StripePaymentReportsQueueDTOTrackedI,
  StripePaymentReportsQueueDTOMeta,
} from "../model";
// @ts-ignore
import type { StripePaymentReportsResultDTO } from "../model";
import {
  StripePaymentReportsResultDTOTrackedI,
  StripePaymentReportsResultDTOMeta,
} from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Gets catalog item reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogItemsGet: (
      queueId?: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/catalog/items`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (queueId !== undefined) {
        localVarQueryParameter["queueId"] = queueId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets catalog item reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<ItemType>} [itemType]
     * @param {boolean} [includeEmpty]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogItemsQueueGet: (
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      itemType?: Array<ItemType>,
      includeEmpty?: boolean,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/catalog/items/queue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (createdOnStart !== undefined) {
        localVarQueryParameter["createdOnStart"] =
          (createdOnStart as any) instanceof Date
            ? (createdOnStart as any).toISOString()
            : createdOnStart;
      }

      if (createdOnEnd !== undefined) {
        localVarQueryParameter["createdOnEnd"] =
          (createdOnEnd as any) instanceof Date
            ? (createdOnEnd as any).toISOString()
            : createdOnEnd;
      }

      if (capturableOnStart !== undefined) {
        localVarQueryParameter["capturableOnStart"] =
          (capturableOnStart as any) instanceof Date
            ? (capturableOnStart as any).toISOString()
            : capturableOnStart;
      }

      if (capturableOnEnd !== undefined) {
        localVarQueryParameter["capturableOnEnd"] =
          (capturableOnEnd as any) instanceof Date
            ? (capturableOnEnd as any).toISOString()
            : capturableOnEnd;
      }

      if (paidOnStart !== undefined) {
        localVarQueryParameter["paidOnStart"] =
          (paidOnStart as any) instanceof Date
            ? (paidOnStart as any).toISOString()
            : paidOnStart;
      }

      if (paidOnEnd !== undefined) {
        localVarQueryParameter["paidOnEnd"] =
          (paidOnEnd as any) instanceof Date
            ? (paidOnEnd as any).toISOString()
            : paidOnEnd;
      }

      if (itemType) {
        localVarQueryParameter["itemType"] = itemType;
      }

      if (includeEmpty !== undefined) {
        localVarQueryParameter["includeEmpty"] = includeEmpty;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets catalog item reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogSummaryGet: (
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/catalog/summary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (createdOnStart !== undefined) {
        localVarQueryParameter["createdOnStart"] =
          (createdOnStart as any) instanceof Date
            ? (createdOnStart as any).toISOString()
            : createdOnStart;
      }

      if (createdOnEnd !== undefined) {
        localVarQueryParameter["createdOnEnd"] =
          (createdOnEnd as any) instanceof Date
            ? (createdOnEnd as any).toISOString()
            : createdOnEnd;
      }

      if (capturableOnStart !== undefined) {
        localVarQueryParameter["capturableOnStart"] =
          (capturableOnStart as any) instanceof Date
            ? (capturableOnStart as any).toISOString()
            : capturableOnStart;
      }

      if (capturableOnEnd !== undefined) {
        localVarQueryParameter["capturableOnEnd"] =
          (capturableOnEnd as any) instanceof Date
            ? (capturableOnEnd as any).toISOString()
            : capturableOnEnd;
      }

      if (paidOnStart !== undefined) {
        localVarQueryParameter["paidOnStart"] =
          (paidOnStart as any) instanceof Date
            ? (paidOnStart as any).toISOString()
            : paidOnStart;
      }

      if (paidOnEnd !== undefined) {
        localVarQueryParameter["paidOnEnd"] =
          (paidOnEnd as any) instanceof Date
            ? (paidOnEnd as any).toISOString()
            : paidOnEnd;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets invalid signup reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsInvalidSignupsGet: (
      queueId?: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/invalid-signups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (queueId !== undefined) {
        localVarQueryParameter["queueId"] = queueId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Queues invalid signup validation report
     * @param {Date | string} startDate
     * @param {Date | string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsInvalidSignupsQueueGet: (
      startDate: Date | string,
      endDate: Date | string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists(
        "staffReportsInvalidSignupsQueueGet",
        "startDate",
        startDate,
      );
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists(
        "staffReportsInvalidSignupsQueueGet",
        "endDate",
        endDate,
      );
      const localVarPath = `/staff/reports/invalid-signups/queue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (startDate !== undefined) {
        localVarQueryParameter["startDate"] =
          (startDate as any) instanceof Date
            ? (startDate as any).toISOString()
            : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter["endDate"] =
          (endDate as any) instanceof Date
            ? (endDate as any).toISOString()
            : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets order reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsOrdersGet: (
      queueId?: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/orders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (queueId !== undefined) {
        localVarQueryParameter["queueId"] = queueId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets order reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<OrderStateNew>} [orderStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsOrdersQueueGet: (
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      orderStatus?: Array<OrderStateNew>,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/orders/queue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (createdOnStart !== undefined) {
        localVarQueryParameter["createdOnStart"] =
          (createdOnStart as any) instanceof Date
            ? (createdOnStart as any).toISOString()
            : createdOnStart;
      }

      if (createdOnEnd !== undefined) {
        localVarQueryParameter["createdOnEnd"] =
          (createdOnEnd as any) instanceof Date
            ? (createdOnEnd as any).toISOString()
            : createdOnEnd;
      }

      if (capturableOnStart !== undefined) {
        localVarQueryParameter["capturableOnStart"] =
          (capturableOnStart as any) instanceof Date
            ? (capturableOnStart as any).toISOString()
            : capturableOnStart;
      }

      if (capturableOnEnd !== undefined) {
        localVarQueryParameter["capturableOnEnd"] =
          (capturableOnEnd as any) instanceof Date
            ? (capturableOnEnd as any).toISOString()
            : capturableOnEnd;
      }

      if (paidOnStart !== undefined) {
        localVarQueryParameter["paidOnStart"] =
          (paidOnStart as any) instanceof Date
            ? (paidOnStart as any).toISOString()
            : paidOnStart;
      }

      if (paidOnEnd !== undefined) {
        localVarQueryParameter["paidOnEnd"] =
          (paidOnEnd as any) instanceof Date
            ? (paidOnEnd as any).toISOString()
            : paidOnEnd;
      }

      if (orderStatus) {
        localVarQueryParameter["orderStatus"] = orderStatus;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets payment reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsPaymentsGet: (
      queueId?: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (queueId !== undefined) {
        localVarQueryParameter["queueId"] = queueId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets payment reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<PaymentStatus>} [paymentStatus]
     * @param {Array<PaymentType>} [paymentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsPaymentsQueueGet: (
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      paymentStatus?: Array<PaymentStatus>,
      paymentType?: Array<PaymentType>,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/payments/queue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (createdOnStart !== undefined) {
        localVarQueryParameter["createdOnStart"] =
          (createdOnStart as any) instanceof Date
            ? (createdOnStart as any).toISOString()
            : createdOnStart;
      }

      if (createdOnEnd !== undefined) {
        localVarQueryParameter["createdOnEnd"] =
          (createdOnEnd as any) instanceof Date
            ? (createdOnEnd as any).toISOString()
            : createdOnEnd;
      }

      if (capturableOnStart !== undefined) {
        localVarQueryParameter["capturableOnStart"] =
          (capturableOnStart as any) instanceof Date
            ? (capturableOnStart as any).toISOString()
            : capturableOnStart;
      }

      if (capturableOnEnd !== undefined) {
        localVarQueryParameter["capturableOnEnd"] =
          (capturableOnEnd as any) instanceof Date
            ? (capturableOnEnd as any).toISOString()
            : capturableOnEnd;
      }

      if (paidOnStart !== undefined) {
        localVarQueryParameter["paidOnStart"] =
          (paidOnStart as any) instanceof Date
            ? (paidOnStart as any).toISOString()
            : paidOnStart;
      }

      if (paidOnEnd !== undefined) {
        localVarQueryParameter["paidOnEnd"] =
          (paidOnEnd as any) instanceof Date
            ? (paidOnEnd as any).toISOString()
            : paidOnEnd;
      }

      if (paymentStatus) {
        localVarQueryParameter["paymentStatus"] = paymentStatus;
      }

      if (paymentType) {
        localVarQueryParameter["paymentType"] = paymentType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets stripe payment reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsStripePaymentsGet: (
      queueId?: string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/stripe-payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (queueId !== undefined) {
        localVarQueryParameter["queueId"] = queueId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets stripe payment reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Array<PaymentStatus>} [paymentStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsStripePaymentsQueueGet: (
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      paymentStatus?: Array<PaymentStatus>,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/reports/stripe-payments/queue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (createdOnStart !== undefined) {
        localVarQueryParameter["createdOnStart"] =
          (createdOnStart as any) instanceof Date
            ? (createdOnStart as any).toISOString()
            : createdOnStart;
      }

      if (createdOnEnd !== undefined) {
        localVarQueryParameter["createdOnEnd"] =
          (createdOnEnd as any) instanceof Date
            ? (createdOnEnd as any).toISOString()
            : createdOnEnd;
      }

      if (paymentStatus) {
        localVarQueryParameter["paymentStatus"] = paymentStatus;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type staffReportsCatalogItemsGetParams = { queueId?: string };
export type staffReportsCatalogItemsQueueGetParams = {
  createdOnStart?: Date | string;
  createdOnEnd?: Date | string;
  capturableOnStart?: Date | string;
  capturableOnEnd?: Date | string;
  paidOnStart?: Date | string;
  paidOnEnd?: Date | string;
  itemType?: Array<ItemType>;
  includeEmpty?: boolean;
};
export type staffReportsCatalogSummaryGetParams = {
  createdOnStart?: Date | string;
  createdOnEnd?: Date | string;
  capturableOnStart?: Date | string;
  capturableOnEnd?: Date | string;
  paidOnStart?: Date | string;
  paidOnEnd?: Date | string;
};
export type staffReportsInvalidSignupsGetParams = { queueId?: string };
export type staffReportsInvalidSignupsQueueGetParams = {
  startDate: Date | string;
  endDate: Date | string;
};
export type staffReportsOrdersGetParams = { queueId?: string };
export type staffReportsOrdersQueueGetParams = {
  createdOnStart?: Date | string;
  createdOnEnd?: Date | string;
  capturableOnStart?: Date | string;
  capturableOnEnd?: Date | string;
  paidOnStart?: Date | string;
  paidOnEnd?: Date | string;
  orderStatus?: Array<OrderStateNew>;
};
export type staffReportsPaymentsGetParams = { queueId?: string };
export type staffReportsPaymentsQueueGetParams = {
  createdOnStart?: Date | string;
  createdOnEnd?: Date | string;
  capturableOnStart?: Date | string;
  capturableOnEnd?: Date | string;
  paidOnStart?: Date | string;
  paidOnEnd?: Date | string;
  paymentStatus?: Array<PaymentStatus>;
  paymentType?: Array<PaymentType>;
};
export type staffReportsStripePaymentsGetParams = { queueId?: string };
export type staffReportsStripePaymentsQueueGetParams = {
  createdOnStart?: Date | string;
  createdOnEnd?: Date | string;
  paymentStatus?: Array<PaymentStatus>;
};

export const staffReportsCatalogItemsGetMeta = {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
};
export const staffReportsCatalogItemsQueueGetMeta = {
  createdOnStart: propertyMeta(
    "createdOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  createdOnEnd: propertyMeta(
    "createdOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnStart: propertyMeta(
    "capturableOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnEnd: propertyMeta(
    "capturableOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnStart: propertyMeta(
    "paidOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnEnd: propertyMeta("paidOnEnd", false, false, false, MetaTypesBase.Date),
  itemType: propertyMeta("itemType", true, false, false, ItemTypeMeta),
  includeEmpty: propertyMeta(
    "includeEmpty",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
};
export const staffReportsCatalogSummaryGetMeta = {
  createdOnStart: propertyMeta(
    "createdOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  createdOnEnd: propertyMeta(
    "createdOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnStart: propertyMeta(
    "capturableOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnEnd: propertyMeta(
    "capturableOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnStart: propertyMeta(
    "paidOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnEnd: propertyMeta("paidOnEnd", false, false, false, MetaTypesBase.Date),
};
export const staffReportsInvalidSignupsGetMeta = {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
};
export const staffReportsInvalidSignupsQueueGetMeta = {
  startDate: propertyMeta("startDate", false, true, false, MetaTypesBase.Date),
  endDate: propertyMeta("endDate", false, true, false, MetaTypesBase.Date),
};
export const staffReportsOrdersGetMeta = {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
};
export const staffReportsOrdersQueueGetMeta = {
  createdOnStart: propertyMeta(
    "createdOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  createdOnEnd: propertyMeta(
    "createdOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnStart: propertyMeta(
    "capturableOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnEnd: propertyMeta(
    "capturableOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnStart: propertyMeta(
    "paidOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnEnd: propertyMeta("paidOnEnd", false, false, false, MetaTypesBase.Date),
  orderStatus: propertyMeta(
    "orderStatus",
    true,
    false,
    false,
    OrderStateNewMeta,
  ),
};
export const staffReportsPaymentsGetMeta = {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
};
export const staffReportsPaymentsQueueGetMeta = {
  createdOnStart: propertyMeta(
    "createdOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  createdOnEnd: propertyMeta(
    "createdOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnStart: propertyMeta(
    "capturableOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  capturableOnEnd: propertyMeta(
    "capturableOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnStart: propertyMeta(
    "paidOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paidOnEnd: propertyMeta("paidOnEnd", false, false, false, MetaTypesBase.Date),
  paymentStatus: propertyMeta(
    "paymentStatus",
    true,
    false,
    false,
    PaymentStatusMeta,
  ),
  paymentType: propertyMeta("paymentType", true, false, false, PaymentTypeMeta),
};
export const staffReportsStripePaymentsGetMeta = {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
};
export const staffReportsStripePaymentsQueueGetMeta = {
  createdOnStart: propertyMeta(
    "createdOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  createdOnEnd: propertyMeta(
    "createdOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentStatus: propertyMeta(
    "paymentStatus",
    true,
    false,
    false,
    PaymentStatusMeta,
  ),
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const useReportApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Gets catalog item reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogItemsGetRaw(
      props: staffReportsCatalogItemsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CatalogItemReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsCatalogItemsGet(
          props.queueId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsCatalogItemsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CatalogItemReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CatalogItemReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets catalog item reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<ItemType>} [itemType]
     * @param {boolean} [includeEmpty]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogItemsQueueGetRaw(
      props: staffReportsCatalogItemsQueueGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CatalogItemReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsCatalogItemsQueueGet(
          props.createdOnStart,
          props.createdOnEnd,
          props.capturableOnStart,
          props.capturableOnEnd,
          props.paidOnStart,
          props.paidOnEnd,
          props.itemType,
          props.includeEmpty,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsCatalogItemsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CatalogItemReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CatalogItemReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets catalog item reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogSummaryGetRaw(
      props: staffReportsCatalogSummaryGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DailySummaryReportsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsCatalogSummaryGet(
          props.createdOnStart,
          props.createdOnEnd,
          props.capturableOnStart,
          props.capturableOnEnd,
          props.paidOnStart,
          props.paidOnEnd,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsCatalogSummaryGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<DailySummaryReportsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("DailySummaryReportsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets invalid signup reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsInvalidSignupsGetRaw(
      props: staffReportsInvalidSignupsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InvalidSignupReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsInvalidSignupsGet(
          props.queueId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsInvalidSignupsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<InvalidSignupReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("InvalidSignupReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Queues invalid signup validation report
     * @param {Date | string} startDate
     * @param {Date | string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsInvalidSignupsQueueGetRaw(
      props: staffReportsInvalidSignupsQueueGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InvalidSignupReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsInvalidSignupsQueueGet(
          props.startDate,
          props.endDate,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsInvalidSignupsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<InvalidSignupReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("InvalidSignupReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets order reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsOrdersGetRaw(
      props: staffReportsOrdersGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffReportsOrdersGet(
        props.queueId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsOrdersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets order reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<OrderStateNew>} [orderStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsOrdersQueueGetRaw(
      props: staffReportsOrdersQueueGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsOrdersQueueGet(
          props.createdOnStart,
          props.createdOnEnd,
          props.capturableOnStart,
          props.capturableOnEnd,
          props.paidOnStart,
          props.paidOnEnd,
          props.orderStatus,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsOrdersQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets payment reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsPaymentsGetRaw(
      props: staffReportsPaymentsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaymentReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsPaymentsGet(
          props.queueId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsPaymentsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaymentReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PaymentReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets payment reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<PaymentStatus>} [paymentStatus]
     * @param {Array<PaymentType>} [paymentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsPaymentsQueueGetRaw(
      props: staffReportsPaymentsQueueGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaymentReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsPaymentsQueueGet(
          props.createdOnStart,
          props.createdOnEnd,
          props.capturableOnStart,
          props.capturableOnEnd,
          props.paidOnStart,
          props.paidOnEnd,
          props.paymentStatus,
          props.paymentType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsPaymentsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaymentReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PaymentReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets stripe payment reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsStripePaymentsGetRaw(
      props: staffReportsStripePaymentsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<StripePaymentReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsStripePaymentsGet(
          props.queueId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsStripePaymentsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<StripePaymentReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("StripePaymentReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets stripe payment reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Array<PaymentStatus>} [paymentStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsStripePaymentsQueueGetRaw(
      props: staffReportsStripePaymentsQueueGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<StripePaymentReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsStripePaymentsQueueGet(
          props.createdOnStart,
          props.createdOnEnd,
          props.paymentStatus,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsStripePaymentsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<StripePaymentReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("StripePaymentReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Gets catalog item reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogItemsGet(
      queueId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CatalogItemReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsCatalogItemsGet(queueId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsCatalogItemsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CatalogItemReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CatalogItemReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets catalog item reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<ItemType>} [itemType]
     * @param {boolean} [includeEmpty]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogItemsQueueGet(
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      itemType?: Array<ItemType>,
      includeEmpty?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CatalogItemReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsCatalogItemsQueueGet(
          createdOnStart,
          createdOnEnd,
          capturableOnStart,
          capturableOnEnd,
          paidOnStart,
          paidOnEnd,
          itemType,
          includeEmpty,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsCatalogItemsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CatalogItemReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CatalogItemReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets catalog item reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsCatalogSummaryGet(
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DailySummaryReportsDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsCatalogSummaryGet(
          createdOnStart,
          createdOnEnd,
          capturableOnStart,
          capturableOnEnd,
          paidOnStart,
          paidOnEnd,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsCatalogSummaryGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<DailySummaryReportsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("DailySummaryReportsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets invalid signup reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsInvalidSignupsGet(
      queueId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InvalidSignupReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsInvalidSignupsGet(
          queueId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsInvalidSignupsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<InvalidSignupReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("InvalidSignupReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Queues invalid signup validation report
     * @param {Date | string} startDate
     * @param {Date | string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsInvalidSignupsQueueGet(
      startDate: Date | string,
      endDate: Date | string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InvalidSignupReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsInvalidSignupsQueueGet(
          startDate,
          endDate,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsInvalidSignupsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<InvalidSignupReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("InvalidSignupReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets order reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsOrdersGet(
      queueId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffReportsOrdersGet(
        queueId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsOrdersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets order reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<OrderStateNew>} [orderStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsOrdersQueueGet(
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      orderStatus?: Array<OrderStateNew>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsOrdersQueueGet(
          createdOnStart,
          createdOnEnd,
          capturableOnStart,
          capturableOnEnd,
          paidOnStart,
          paidOnEnd,
          orderStatus,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsOrdersQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets payment reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsPaymentsGet(
      queueId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaymentReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsPaymentsGet(queueId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsPaymentsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaymentReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PaymentReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets payment reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Date | string} [capturableOnStart]
     * @param {Date | string} [capturableOnEnd]
     * @param {Date | string} [paidOnStart]
     * @param {Date | string} [paidOnEnd]
     * @param {Array<PaymentStatus>} [paymentStatus]
     * @param {Array<PaymentType>} [paymentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsPaymentsQueueGet(
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      capturableOnStart?: Date | string,
      capturableOnEnd?: Date | string,
      paidOnStart?: Date | string,
      paidOnEnd?: Date | string,
      paymentStatus?: Array<PaymentStatus>,
      paymentType?: Array<PaymentType>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaymentReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsPaymentsQueueGet(
          createdOnStart,
          createdOnEnd,
          capturableOnStart,
          capturableOnEnd,
          paidOnStart,
          paidOnEnd,
          paymentStatus,
          paymentType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsPaymentsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaymentReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PaymentReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets stripe payment reports
     * @param {string} [queueId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsStripePaymentsGet(
      queueId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<StripePaymentReportsResultDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsStripePaymentsGet(
          queueId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsStripePaymentsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<StripePaymentReportsResultDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("StripePaymentReportsResultDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets stripe payment reports
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {Array<PaymentStatus>} [paymentStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffReportsStripePaymentsQueueGet(
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      paymentStatus?: Array<PaymentStatus>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<StripePaymentReportsQueueDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffReportsStripePaymentsQueueGet(
          createdOnStart,
          createdOnEnd,
          paymentStatus,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportApi.staffReportsStripePaymentsQueueGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<StripePaymentReportsQueueDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("StripePaymentReportsQueueDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * ReportApi - interface
 * @export
 * @interface ReportApi
 */
export interface ReportApiInterface {
  /**
   * Gets catalog item reports
   * @param {string} [queueId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsCatalogItemsGet(
    queueId?: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CatalogItemReportsResultDTO>;

  /**
   * Gets catalog item reports
   * @param {string} [createdOnStart]
   * @param {string} [createdOnEnd]
   * @param {string} [capturableOnStart]
   * @param {string} [capturableOnEnd]
   * @param {string} [paidOnStart]
   * @param {string} [paidOnEnd]
   * @param {Array<ItemType>} [itemType]
   * @param {boolean} [includeEmpty]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsCatalogItemsQueueGet(
    createdOnStart?: Date | string,
    createdOnEnd?: Date | string,
    capturableOnStart?: Date | string,
    capturableOnEnd?: Date | string,
    paidOnStart?: Date | string,
    paidOnEnd?: Date | string,
    itemType?: Array<ItemType>,
    includeEmpty?: boolean,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CatalogItemReportsQueueDTO>;

  /**
   * Gets catalog item reports
   * @param {string} [createdOnStart]
   * @param {string} [createdOnEnd]
   * @param {string} [capturableOnStart]
   * @param {string} [capturableOnEnd]
   * @param {string} [paidOnStart]
   * @param {string} [paidOnEnd]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsCatalogSummaryGet(
    createdOnStart?: Date | string,
    createdOnEnd?: Date | string,
    capturableOnStart?: Date | string,
    capturableOnEnd?: Date | string,
    paidOnStart?: Date | string,
    paidOnEnd?: Date | string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<DailySummaryReportsDTO>;

  /**
   * Gets invalid signup reports
   * @param {string} [queueId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsInvalidSignupsGet(
    queueId?: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<InvalidSignupReportsResultDTO>;

  /**
   * Queues invalid signup validation report
   * @param {string} startDate
   * @param {string} endDate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsInvalidSignupsQueueGet(
    startDate: Date | string,
    endDate: Date | string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<InvalidSignupReportsQueueDTO>;

  /**
   * Gets order reports
   * @param {string} [queueId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsOrdersGet(
    queueId?: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderReportsResultDTO>;

  /**
   * Gets order reports
   * @param {string} [createdOnStart]
   * @param {string} [createdOnEnd]
   * @param {string} [capturableOnStart]
   * @param {string} [capturableOnEnd]
   * @param {string} [paidOnStart]
   * @param {string} [paidOnEnd]
   * @param {Array<OrderStateNew>} [orderStatus]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsOrdersQueueGet(
    createdOnStart?: Date | string,
    createdOnEnd?: Date | string,
    capturableOnStart?: Date | string,
    capturableOnEnd?: Date | string,
    paidOnStart?: Date | string,
    paidOnEnd?: Date | string,
    orderStatus?: Array<OrderStateNew>,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderReportsQueueDTO>;

  /**
   * Gets payment reports
   * @param {string} [queueId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsPaymentsGet(
    queueId?: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PaymentReportsResultDTO>;

  /**
   * Gets payment reports
   * @param {string} [createdOnStart]
   * @param {string} [createdOnEnd]
   * @param {string} [capturableOnStart]
   * @param {string} [capturableOnEnd]
   * @param {string} [paidOnStart]
   * @param {string} [paidOnEnd]
   * @param {Array<PaymentStatus>} [paymentStatus]
   * @param {Array<PaymentType>} [paymentType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsPaymentsQueueGet(
    createdOnStart?: Date | string,
    createdOnEnd?: Date | string,
    capturableOnStart?: Date | string,
    capturableOnEnd?: Date | string,
    paidOnStart?: Date | string,
    paidOnEnd?: Date | string,
    paymentStatus?: Array<PaymentStatus>,
    paymentType?: Array<PaymentType>,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PaymentReportsQueueDTO>;

  /**
   * Gets stripe payment reports
   * @param {string} [queueId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsStripePaymentsGet(
    queueId?: string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<StripePaymentReportsResultDTO>;

  /**
   * Gets stripe payment reports
   * @param {string} [createdOnStart]
   * @param {string} [createdOnEnd]
   * @param {Array<PaymentStatus>} [paymentStatus]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApiInterface
   */
  staffReportsStripePaymentsQueueGet(
    createdOnStart?: Date | string,
    createdOnEnd?: Date | string,
    paymentStatus?: Array<PaymentStatus>,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<StripePaymentReportsQueueDTO>;
}
